export default __webpack_public_path__ + "f5f660388e7999406d1d6335534b58bb.png";